import {memo} from "react";
import {Progress} from "antd";
import {Link} from "react-router-dom";
import {numberFormat} from "~/utils";
import FontAwesomeIcon from "~/components/FontAwesome";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Trạng thái chi lương trong kỳ cho Dashboard Kế toán trưởng.
 * Dữ liệu: dashboardApi.accountingSalary() = { total{target, paid, remaining, employees} }.
 */
function AccountingSalaryWidget({data, loading = false}) {

	const total = data?.total || {target: 0, paid: 0, remaining: 0, employees: 0};

	const percent = total.target > 0 ? Math.min(100, Math.round(total.paid / total.target * 100)) : 0;

	const link = (
		<Link to="/salary-payment" style={{color: '#fff', fontSize: 12, display: 'inline-flex', alignItems: 'center', gap: 4}}>
			Chi lương <FontAwesomeIcon icon="fa-light fa-arrow-up-right-from-square" />
		</Link>
	);

	const row = (label, value, color) => (
		<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0'}}>
			<span style={{fontSize: 12, color: '#64748b'}}>{label}</span>
			<b style={{fontSize: 14, color}}>{numberFormat(value)}</b>
		</div>
	);

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(217,119,6,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader
				icon="fa-light fa-money-check-dollar-pen"
				title="Chi lương trong kỳ"
				gradient="linear-gradient(135deg, #b45309 0%, #e47d0a 60%, #f59e0b 100%)"
				badge={total.employees ? `${total.employees} NV` : null}
				extra={link}
			/>
			<div style={{padding: '14px 18px'}}>
				{loading
					? <div style={{textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: '12px 0'}}>Đang tải...</div>
					: (
						<>
							<div style={{display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8}}>
								<Progress
									type="circle"
									percent={percent}
									size={62}
									strokeColor={percent >= 100 ? '#059669' : '#f59e0b'}
								/>
								<div style={{flex: 1, minWidth: 0}}>
									{row('Cần trả', total.target, '#334155')}
									{row('Đã trả', total.paid, '#059669')}
									{row('Còn lại', total.remaining, total.remaining > 0 ? '#ef4444' : '#94a3b8')}
								</div>
							</div>
							<div style={{textAlign: 'center', marginTop: 6}}>
								<Link to="/salary-payment" style={{fontSize: 12, color: '#d97706'}}>
									{total.remaining > 0 ? 'Còn lương chưa chi →' : 'Đã chi đủ lương kỳ này'}
								</Link>
							</div>
						</>
					)
				}
			</div>
		</div>
	);
}

export default memo(AccountingSalaryWidget);
